module.exports = __webpack_public_path__ + "static/src/nrl-teams/images/knights.82771fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/nrl-teams/images/knights.png
// module id = nG7k
// module chunks = 0